(function () {
    'use strict';

    angular
        .module('app')
        .factory('debug', debug);

    debug.$inject = ['$window'];

    function debug($window) {
        var service = {
            log: log,
            info: info,
            error: error,
            warn: warn,
        };

        return service;

        /**
         * Get a stack trace.
         *
         * @returns {*|string|String} A multi-row string with a stack trace.
         */
        function getStack() {
            try {
                throw new Error();
            } catch (e) {
                return e.stack;
            }
        }

        /**
         * Get the function that called the log function from the stack trace.
         *
         * @returns {string} A string containing the callee function, file and row.
         */
        function getCaller() {
            var stack = getStack();
            var rows = stack.split('\n');

            if ($window.navigator.userAgent.indexOf('Firefox') !== -1) {
                var matches = rows[3].match(/^([\w-]+)\/?\<?@https?:\/\/([^\/]+)\/([^:]+):(\d+):(\d+)$/); // eslint-disable-line no-useless-escape

                //     get/<@http://admin.local.se/js/app.js?v=33bb722:878:29
                if (matches) {
                    return matches[1] + '() in ' + matches[3].split('?')[0] + ' [' + matches[4] + ', ' + matches[5] + ']';
                }

            } else if ($window.navigator.userAgent.indexOf('Chrome') !== -1) {
                var matches1 = rows[4].match(/^\s+at\s([\w]+)\s\(([^:]+):(\d+)(:(\d+))?\)$/),
                    matches2 = rows[4].match(/^\s+at\shttps?:\/\/([^\/]+)\/([^:]+):(\d+)(:(\d+))?$/),// eslint-disable-line no-useless-escape
                    matches3 = rows[4].match(/^\s+at\s([\w]+)\s\(https?:\/\/([^\/]+)\/([^:]+):(\d+)(:(\d+))?\)$/); // eslint-disable-line no-useless-escape

                if (matches1) {
                    if (!matches1[5]) {
                        matches1[5] = '?';
                    }
                    return matches1[1] + '() in ' + matches1[2].split('?')[0] + ' [' + matches1[3] + ', ' + matches1[5] + ']';
                } else if (matches2) {
                    if (!matches2[5]) {
                        matches2[5] = '?';
                    }
                    return 'anonymous function in ' + matches2[2].split('?')[0] + ' [' + matches2[3] + ', ' + matches2[5] + ']';
                } else if (matches3) {
                    if (!matches3[6]) {
                        matches3[6] = '?';
                    }

                    return matches3[1] + '() in ' + matches3[3].split('?')[0] + ' [' + matches3[4] + ', ' + matches3[6] + ']';
                }
            }

            return rows.slice(0, 5);
        }

        /**
         * Wrapper for console.log().
         *
         * @return {void} empty
         */
        function log() {
            if (window.config.debug) {
                console.log.apply(null, arguments); // eslint-disable-line no-console
                console.log('\tCalled from: ' + getCaller()); // eslint-disable-line no-console
            }
        }

        /**
         * Wrapper for console.info().
         *
         * @return {void} empty
         */
        function info() {
            if (window.config.debug) {
                console.info.apply(null, arguments); // eslint-disable-line no-console
                console.log('\tCalled from: ' + getCaller()); // eslint-disable-line no-console
            }
        }

        /**
         * Wrapper for console.error().
         *
         * @return {void} empty
         */
        function error() {
            if (window.config.debug) {
                console.error.apply(null, arguments); // eslint-disable-line no-console
                console.log('\tCalled from: ' + getCaller()); // eslint-disable-line no-console
            }
        }

        /**
         * Wrapper for console.warn().
         *
         * @return {void} empty
         */
        function warn() {
            if (window.config.debug) {
                console.warn.apply(null, arguments); // eslint-disable-line no-console
                console.log('\tCalled from: ' + getCaller()); // eslint-disable-line no-console
            }
        }
    }

})();